import { Component, ViewEncapsulation } from '@angular/core';
@Component({
  selector: 'dialog-alert',
  templateUrl: './dialog-alert.component.html',
  styleUrls: ['./dialog-alert.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class DialogAlertComponent { }
